import type { ResolvedAddress } from '@/admin/hooks/use-lookups'

export const EMPTY_ADDRESS: ResolvedAddress = {
  line_1: '',
  line_2: '',
  town_or_city: '',
  county: '',
  postcode: '',
  country: '',
}

export function normaliseAddressObject(value: unknown): ResolvedAddress {
  if (!value || typeof value !== 'object') return { ...EMPTY_ADDRESS }
  const source = value as Record<string, unknown>
  // Unwrap the backend attribute-value storage format: { display: "...", value: {...} }.
  // When a property's address attribute has been saved before, the API returns the address
  // wrapped in an outer object; we pull the inner `value` out before reading fields.
  const inner: Record<string, unknown> =
    source.value && typeof source.value === 'object' && !Array.isArray(source.value)
      ? (source.value as Record<string, unknown>)
      : source
  return {
    line_1: String(inner.line_1 ?? inner.addressLine1 ?? inner.address_line_1 ?? ''),
    line_2: String(inner.line_2 ?? inner.addressLine2 ?? inner.address_line_2 ?? ''),
    town_or_city: String(inner.town_or_city ?? inner.locality ?? ''),
    county: String(inner.county ?? inner.region ?? ''),
    postcode: String(inner.postcode ?? inner.postalCode ?? inner.postal_code ?? ''),
    country: String(inner.country ?? inner.countryCode ?? inner.country_code ?? ''),
  }
}

export function formatAddress(address: Partial<ResolvedAddress> | null | undefined): string {
  if (!address) return ''
  return [
    address.line_1,
    address.line_2,
    address.town_or_city,
    address.county,
    address.postcode,
    address.country,
  ]
    .filter((part): part is string => !!part?.trim())
    .join(', ')
}
